module.exports = __webpack_public_path__ + "img/5g_model_groen_beck.eecd36e4.png";